import React from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import NoSSR from '../NoSSR';
import Script from 'next/script';

const Testimonials = ({ className, items }) => {

  function feefo() {
    return <Script src="https://api.feefo.com/api/javascript/earthstream-global-limited-group" />;
  }

  return (
    <div className={classes.testimonials}>
      <div className={classes.header}>
        <Title tag="h2" title="WHAT THEY SAY ABOUT US" className={`quaternary ${classes.header_title}`} highlight={false} variant="quaternary" />
        <div id="feefo-service-review-carousel-widgetId" className="feefo-review-carousel-widget-service"></div>
        <NoSSR>{feefo}</NoSSR>
      </div>
    </div>
  )
}

export default Testimonials